import EkgTable from './EkgTable'

export default EkgTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/EkgTable/index.js